import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: ${theme.spacing.md};
  gap: ${theme.spacing.lg};
`
export const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: ${theme.spacing.md};
`

export const TextRow = styled.div`
  display: flex;
  flex-grow: 1;
  gap: ${theme.spacing.lg};
`

export const TextCol = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: ${theme.spacing.lg};
`

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: ${theme.spacing.md};
`
export const FormActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: ${theme.spacing.sm};
`
export const YrbaText = styled.span`
  font-size: ${theme.typography.sizes.xs};
  & > b {
    color: ${theme.colors.alert.warning.darker};
  }
`
